import PageHeader from "@/components/PageHeader";
import VenueCard from "@/components/VenueCard";
import { MOCK_VENUES } from "@/lib/mockData";

const Venues = () => {
  return (
    <div data-testid="venues-page">
      <PageHeader title="Venues" subtitle="Partner spots with active deals." />
      <div className="space-y-4">
        {MOCK_VENUES.map((v, i) => (
          <VenueCard key={v.id} venue={v} index={i} />
        ))}
      </div>
    </div>
  );
};

export default Venues;
